import { render, staticRenderFns } from "./CompanyDetailsSettingsTab.vue?vue&type=template&id=70e18d50"
import script from "./CompanyDetailsSettingsTab.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports